export const reviewDataRow1 = [
  {
    name: "ark****",
    content:
      "어버이날 선물로 골랐는데 너무 만족스러워요 ㅠㅠ 친절하게 전화주시고 필름까지 부착!! 이거 보고 좋아하실 아빠 얼글 생각하니 미소가 절로 나오네요. 사은품도 잘 받았고 주말에 내려가서 효도하고 올게요 감사합니다~",
  },
  {
    name: "blue****",
    content:
      "좋은제품 좋은가격에 잘 구매했어요 액정보호필름도 붙여주시고 충전기 또 빠른바송에 너무 만족합니다 잘쓸까요^^",
  },
  {
    name: "nine****",
    content:
      "기존폰이 4년 정도 되서 폰을 찾던 중에 자급제폰를 알게되서 약간의 불안한 마음으로 주문했는데 배송 완전 빠르고 기계상태며 모든것에 만족스러워요 거기에 사은품 까지 챙겨주시고 너무 좋아요~^^",
  },
  {
    name: "bora******",
    content:
      "솔직히 걱정엄청 했는데 받아보니 걱정 싹 사라졌습니다~~ 유심갈아끼우고 겉에 필름부착하니 새폰이네요~!! 담에도 또 이용할게요~! 베이지 색상도 예쁘네요^^ 예쁜 케이스하나 사서 보호해줘야겠어요",
  },
  {
    name: "vhor***",
    content:
      "왜 진작 안사고 고민 했는지 후회가~, 지금이라도 구입해서 다행이네요",
  },
  {
    name: "mill***",
    content:
      "일단 제품 완전 새거 같구요. 판매자님 응답도 빠르고 친절하세요. 여러군데 비교해 보고 톡도 보내봤는데 여기가 진짜 자급제폰이에요. 잘 쓸께요",
  },
  {
    name: "sky3*****",
    content:
      "배송도 빠르고 따로 문자도 주셔서 설명도 잘 하주셨습니다. 선물로 산건데.받은 사람도 정말 좋아하고 너무 기분 좋 네요!! 앞으로도 좋은 상품 합리적인 가격에 많이 판매해주세요 하자 없는 상품과 서비스 물품들도 감사합니다.",
  },
  {
    name: "Zsa9***",
    content:
      "무지 빠른 배송과 빵빵한 완충포장! 친절하게 응대 해주시고 필름과 사은품까지 너무너무 만족합니다 혹시 고민하는 분 계시면 그럴 필요 없습니다",
  },
  {
    name: "hyun*****",
    content:
      "배송도 하루 안걸리고 기스도 없고 꼼꼼하게 포장해서 보내주셨네요. 잘 사용하고 다음에도 살일이 있으면 구매할게요",
  },
  {
    name: "raw*******",
    content:
      "정말 빠른 배송 감사합니다 그리고 새것과 다름 없는 컨디션이에요! 정말 잘 구매했습니다!!",
  },
];
export const reviewDataRow2 = [
  {
    name: "hyd5***",
    content:
      "세달째 사용해가는데... 너무너머 좋아용 아이폰에서 갈아타기를 잘해씀!",
  },
  {
    name: "coff******",
    content:
      "가장 저렴하게 판매하는 곳인 것 같아요. 배송도 다음날 바로 도착했고, 제품도 이상 없습니다. 라벤더 색상 너무 예쁘 고요. 최고입니다!!",
  },
  {
    name: "wd13***",
    content:
      "궁금한점 있으면 친절하고 빠르게 대답도 해주시고!! 비싸서 저렴한곳 찾다가 너무 좋은 곳을 찾았네요!! 너무 감사합니다!! 필름이랑 케이스도 너무 잘쓸게요",
  },
  {
    name: "zhsk*****",
    content:
      "배송 빠르고 주문 다음날 친절하게 필름 부착 여부 문자와서 좋았구요, 사은품도 맘에 들더라구요~ 우체국 택배 담날 오전에 와서 깜놀 했어요~ㅋ",
  },
  {
    name: "happ******",
    content:
      "상품 보내주시기 전에 확인 문자 주셨어요. 저렴한 가격에 사은품, 빠른 배송까지 완벽합니다~ 예전 폰 정보 바로 옮기고 삼성케어서비스까지 등록 완료해서 이제 오래오래 쓰기만 하면 되겠어요 하 잘 쓰겠습니다.",
  },
  {
    name: "aldi****",
    content:
      "배송도 빠르고 필름도 붙여주시고 감사합니다 아이 졸업선물로 사준건데 당분간 엄청 말 잘 들을거 같습니다~~ 그걸로 만족합니다",
  },
  {
    name: "dkwl********",
    content:
      "상태가 A급이상 인데요? 굳이 스크래치 있는부분만 찍자면 이렇습니다. 걱정했었는데 너무 마음에듭니다~! 필름 지문인식잘되구요! 케이스랑 충전기까지 있을건 다 있네요 감사합니다~",
  },
  {
    name: "gaon**",
    content:
      "오후에 주문했는데 다음날 배송되니 더 좋네요. 폰이야 말할것도 없이 좋구요. 흠집하나없었고, 화면액정이 깔끔하게 붙어져있어서 더 만족합니다. 오랜만에 폰을 바꿔서인지 유심이 저절로 락이 걸린줄도 모르고 데이터가 안되서 고민 했네요. 추천합니다!",
  },
  {
    name: "in****",
    content:
      "저렴하게 잘샀고 판매자분의 친절함과 사은품선물 감사해요 배송도 초고속이었어요",
  },
  {
    name: "ddin****",
    content:
      "나름 최저가구매였음 판매자 안내가 고가의 상품을 인터넷구매하는 불안을 해소해줘서 만족함.",
  },
];
